module.exports = __webpack_public_path__ + "static/media/top-sport-image.04786eea.webp";